import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { CallToActionType } from "@omni/types/api/cart/bff/shared/enums/callToActionType.enum";
import { useEffect } from "react";

import ChangeStore from "@/components/CallToActions/ChangeStore/changeStore.component";
import { useThunkDispatch } from "@/redux/dispatcher";
import {
    CTAAction,
    CTAActions
} from "@/redux/modules/api/data/cart/@types/cart.types";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import { translateWithoutContext } from "@/redux/modules/value/translations/translations.helpers";
import { TApiAction } from "@/redux/store.types";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    stores: Array<string>;
    productParams: Array<string>;
    product: CartItem | null;
};

const ChangeStoreAction = ({
    stores = [],
    product,
    productParams: _productParams = []
}: Props) => {
    const dispatch = useThunkDispatch();
    const { closeDialog, setLoading, addMessage } = useCallToActionsContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (stores.length === 0) {
            addMessage(
                CallToActionType.CHANGE_STORE,
                translateWithoutContext("general.cta.changeStore.noStores")
            );
        }
    }, [stores.length]);

    const onChangeStore = (shopId: string) => {
        setLoading(true);
        dispatch(CartModule.changeStore(shopId)).then((action: TApiAction) => {
            if (action.type === CartModule.APIStatus.SUCCESS) {
                closeDialog();
            }
        });
    };

    return (
        <ChangeStore
            onChangeStore={onChangeStore}
            stores={stores}
            product={product}
        />
    );
};

const changeStore: CTAAction = (
    product: CartItem | null,
    action: CTAActions
) => {
    const stores = action.parameters;

    return (
        <ChangeStoreAction
            stores={stores}
            product={product}
            productParams={action.productParameters}
        />
    );
};

export default changeStore;
